export default "__VITE_ASSET__1870814d__"